/**
 * Bounded Context: Conversation — composable
 *
 * Usa `storeToRefs` para que refs permaneçam reativas quando consumidas
 * em templates.
 */

import { storeToRefs } from "pinia";
import { useConversationStore } from "../store";
import type { Message, Role } from "../types";

export function useConversation() {
  const store = useConversationStore();
  const refs = storeToRefs(store);
  return {
    /** Refs reativas (auto-unwrapped no template). */
    messages: refs.messages,
    maxMessages: store.maxMessages,
    /** Ações. */
    append: (role: Role, text: string): Message => store.append(role, text),
    clear: (): void => store.clear(),
  };
}
